export default [
  {
    label: "Ancient Near East Literature (2600 BCE–330 BCE)",
    value: "Ancient Near East Literature (2600 BCE-330 BCE)"
  },
  {
    label: "Ancient Greek and Roman Period (800 BCE–500 AD)",
    value: "Ancient Greek and Roman Period (800 BCE-500 AD)"
  },
  {
    label: "Chinese Spring and Autumn Period (771 BCE–476 BCE)",
    value: "Chinese Spring and Autumn Period (771 BCE-476 BCE)"
  },
  {
    label: "Ancient Indian Literature (Before 500)",
    value: "Ancient Indian Literature (Before 500)"
  },
  {
    label: "Pre-Colonial African Period (Before 1500)",
    value: "Pre-Colonial African Period (Before 1500)"
  },
  {
    label: "Pre-Conquest South American Period (Before 1492)",
    value: "Pre-Conquest South American Period (Before 1492)"
  },
  {
    label: "Old English Period (450–1066)",
    value: "Old English Period (450-1066)"
  },
  {
    label: "Medieval European period (500–1500)",
    value: "Medieval European period (500-1500)"
  },
  {
    label: "Japanese Heian Period (794–1185)",
    value: "Japanese Heian Period (794-1185)"
  },
  {
    label: "Middle English Period (1066–1500)",
    value: "Middle English Period (1066-1500)"
  },
  {
    label: "The Renaissance (1300–1660)",
    value: "The Renaissance (1300-1660)"
  },
  {
    label: "English Renaissance (1485–1660)",
    value: "English Renaissance (1485-1660)"
  },
  {
    label: "The Spanish Golden Age (1556–1659)",
    value: "The Spanish Golden Age (1556-1659)"
  },
  {
    label: "Elizabethan Period (1558–1603)",
    value: "Elizabethan Period (1558-1603)"
  },
  {
    label: "French Grand Siècle (1601–1715)",
    value: "French Grand Siècle (1601-1715)"
  },
  {
    label: "Jacobean Period (1603–1625)",
    value: "Jacobean Period (1603-1625)"
  },
  {
    label: "American Colonial Period (1607–1775)",
    value: "American Colonial Period (1607-1775)"
  },
  {
    label: "Caroline Period (1625–1649)",
    value: "Caroline Period (1625-1649)"
  },
  {
    label: "Commonwealth Period (1649–1660)",
    value: "Commonwealth Period (1649-1660)"
  },
  {
    label: "The Restoration (1660–1700)",
    value: "The Restoration (1660-1700)"
  },
  {
    label: "English Neoclassical Period (1660–1785)",
    value: "English Neoclassical Period (1660-1785)"
  },
  {
    label: "Augustan Period (1700–1745)",
    value: "Augustan Period (1700-1745)"
  },
  {
    label: "Age of Enlightenment (1650–1800)",
    value: "Age of Enlightenment (1650-1800)"
  },
  {
    label: "The Great Awakening (1730–1749)",
    value: "The Great Awakening (1730-1749)"
  },
  {
    label: "Age of Sensibility (1745–1785)",
    value: "Age of Sensibility (1745-1785)"
  },
  {
    label: "American Early National Period (1775–1830)",
    value: "American Early National Period (1775-1830)"
  },
  {
    label: "European Romantic Period (1775–1850)",
    value: "European Romantic Period (1775-1850)"
  },
  {
    label: "German Romantic Period (1775–1830)",
    value: "German Romantic Period (1775-1830)"
  },
  {
    label: "English Romantic Period (1785–1837)",
    value: "English Romantic Period (1785-1837)"
  },
  {
    label: "Russian Golden Age of Literature (1801–1900)",
    value: "Russian Golden Age of Literature (1801-1900)"
  },
  {
    label: "French Romantic Period (1815–1850)",
    value: "French Romantic Period (1815-1850)"
  },
  {
    label: "American Romantic Period (1828–1865)",
    value: "American Romantic Period (1828-1865)"
  },
  {
    label: "Victorian Period (1837–1901)",
    value: "Victorian Period (1837-1901)"
  },
  {
    label: "Realist and Naturalist Period (1840–1910)",
    value: "Realist and Naturalist Period (1840-1910)"
  },
  {
    label: "Irish Literary Revival (1880–1930)",
    value: "Irish Literary Revival (1880-1930)"
  },
  {
    label: "Modern Period (1901–1945)",
    value: "Modern Period (1901-1945)"
  },
  {
    label: "Harlem Renaissance (1918–1937)",
    value: "Harlem Renaissance (1918-1937)"
  },
  {
    label: "Postmodern and Contemporary Period (1946–Present)",
    value: "Postmodern and Contemporary Period (1946-Present)"
  }
];
